import { ListPageHeaderProps } from '../../../../ui/components/pure/page-headers/list/list-page-header.component';
import { CustomOrderStatusOptions, orderStatusToLabelWithCategory } from '../../orders.constants';
import { UseQueryListOrdersParams } from '../../orders.queries';
import { makeDefineOrdersListActions, OrdersListActions } from '../actions/orders-list.actions';
import { ControlPoint } from '@mui/icons-material';
import { Permissions } from '../../../../core/permissions/permissions.typings';
import { BookingFlowType } from '../../../../ui/enums/booking-flow-type.enum';
import { deliveredVerbForBookingFlowType } from '../../../../ui/util/delivered.verb';

export function makeOrdersListPageHeaderProps(
  projectID: string,
  ordersCount: number,
  form: UseQueryListOrdersParams,
  onFormInput: (update: Partial<UseQueryListOrdersParams>) => void,
  onClickBookOrder: () => void,
  setAction: (action: OrdersListActions) => void,
  hubFilter: { options: { label: string; value: string }[]; loading: boolean; onOpen(): void },
  bookingFlowType: BookingFlowType
): ListPageHeaderProps<UseQueryListOrdersParams> {
  const orderStatusOptions = makeOrderStatusOptions(bookingFlowType);

  return {
    title: 'Orders',
    subtitle: `${ordersCount} Order${ordersCount === 1 ? '' : 's'}`,
    controls: {
      form,
      onFormInput,
      singleAction: {
        label: 'Book Order',
        Icon: ControlPoint,
        onClick: onClickBookOrder,
        permission: {
          action: Permissions.deliveries.create,
          projectID
        }
      },
      menu: {
        actions: makeDefineOrdersListActions()(setAction)
      },
      inputs: [
        {
          type: 'select',
          label: 'Status',
          field: 'status',
          options: orderStatusOptions,
          isAdvanced: true
        },
        {
          type: 'auto-complete',
          label: 'Hub',
          field: 'hubID',
          ...hubFilter,
          isAdvanced: true
        },
        {
          type: 'date-range',
          fromLabel: 'Delivered from',
          fromField: 'fromDate',
          toLabel: 'Delivered to',
          toField: 'toDate',
          isAdvanced: true
        },
        {
          type: 'text',
          label: 'Search',
          field: 'searchTerm'
        }
      ]
    }
  };
}

function makeOrderStatusOptions(
  bookingFlowType: BookingFlowType
): { label: string; value: CustomOrderStatusOptions | '' }[] {
  return [
    { label: 'All statuses', value: '' },
    ...[
      CustomOrderStatusOptions.NotDelivered,
      CustomOrderStatusOptions.DeliveredOffline,
      CustomOrderStatusOptions.Booked,
      CustomOrderStatusOptions.Cancelled,
      CustomOrderStatusOptions.CurrentDeliveriesCategory,
      CustomOrderStatusOptions.Delivered,
      CustomOrderStatusOptions.Overdue,
      CustomOrderStatusOptions.RetrievalRequired,
      CustomOrderStatusOptions.Completed,
      CustomOrderStatusOptions.Collected,
      CustomOrderStatusOptions.Retrieved
    ].map((status) => ({
      label:
        status === CustomOrderStatusOptions.Delivered && bookingFlowType === BookingFlowType.INVENTORY
          ? `- ${deliveredVerbForBookingFlowType(bookingFlowType)}`
          : orderStatusToLabelWithCategory[status],
      value: status
    }))
  ];
}
